/* RSF Product (PDP) — variant select price update + review stars sync. */

(function () {
  'use strict';

  /* ────────────────────────────────────────────────────────────────
     Variant select: aggiorna prezzo e disponibilità CTA su change
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-rsf-variant-select]').forEach((select) => {
    const root = select.closest('[data-section-id]');
    if (!root) return;
    const priceEl = root.querySelector('[data-rsf-price]');
    const ctaEl = root.querySelector('[data-rsf-cta]');

    select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      const price = opt.dataset.price || '';
      const compareAt = opt.dataset.compareAtPrice || '';
      const available = opt.dataset.available === 'true';

      if (priceEl) {
        // Compare-at solo se diversa dal prezzo (Shopify rende stringa "$0.00" se assente)
        if (compareAt && compareAt !== price && compareAt !== '$0.00' && compareAt !== '€0,00') {
          priceEl.innerHTML = `<del>${compareAt}</del> ${price}`;
        } else {
          priceEl.textContent = price;
        }
      }
      if (ctaEl) {
        if (available) {
          ctaEl.disabled = false;
          ctaEl.removeAttribute('aria-disabled');
          ctaEl.textContent = 'Add to cart';
        } else {
          ctaEl.disabled = true;
          ctaEl.setAttribute('aria-disabled', 'true');
          ctaEl.textContent = 'Sold out';
        }
      }
    });
  });

  /* ────────────────────────────────────────────────────────────────
     Review form: stelle interattive nel form body, sync nel summary
     ──────────────────────────────────────────────────────────────── */
  const STAR_FULL = '★';
  const STAR_EMPTY = '☆';

  document.querySelectorAll('[data-rsf-review]').forEach((accordion) => {
    const summaryStars = accordion.querySelector('[data-rsf-summary-stars]');
    const buttons = accordion.querySelectorAll('[data-rsf-star]');
    let currentRating = 0;

    const render = (rating) => {
      buttons.forEach((btn, i) => {
        btn.textContent = i < rating ? STAR_FULL : STAR_EMPTY;
      });
      if (summaryStars) {
        summaryStars.textContent = (STAR_FULL.repeat(rating) + STAR_EMPTY.repeat(5 - rating));
      }
    };

    buttons.forEach((btn) => {
      const value = parseInt(btn.dataset.rsfStar, 10);
      btn.addEventListener('mouseenter', () => render(value));
      btn.addEventListener('mouseleave', () => render(currentRating));
      btn.addEventListener('click', () => {
        currentRating = value;
        render(currentRating);
      });
    });

    const form = accordion.querySelector('[data-rsf-review-form]');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        // TODO: collegare a backend reviews (Judge.me?)
        alert('Review sent — thank you!');
        form.reset();
        currentRating = 0;
        render(0);
      });
    }
  });

  /* ────────────────────────────────────────────────────────────────
     Download all images: fetch tutte le immagini → ZIP via JSZip → download
     JSZip caricato lazy da CDN solo al primo click (non impatta first paint).
     ──────────────────────────────────────────────────────────────── */
  const JSZIP_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
  let jszipPromise = null;

  function loadJSZip() {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (jszipPromise) return jszipPromise;
    jszipPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = JSZIP_CDN;
      s.onload = () => resolve(window.JSZip);
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return jszipPromise;
  }

  document.querySelectorAll('[data-rsf-download-all]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const grid = btn.closest('[data-rsf-download-grid]');
      if (!grid) return;
      const items = grid.querySelectorAll('[data-rsf-download-img]');
      if (!items.length) return;

      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Preparing...';

      try {
        const JSZip = await loadJSZip();
        const zip = new JSZip();
        const handle = grid.dataset.productHandle || 'product';

        let done = 0;
        await Promise.all(Array.from(items).map(async (a, i) => {
          const url = a.href;
          const filename = a.dataset.filename || `${handle}-${i + 1}.jpg`;
          const res = await fetch(url);
          if (!res.ok) throw new Error('Fetch failed: ' + url);
          const blob = await res.blob();
          zip.file(filename, blob);
          done++;
          btn.textContent = `Preparing... ${done}/${items.length}`;
        }));

        btn.textContent = 'Zipping...';
        const content = await zip.generateAsync({ type: 'blob' });
        const dlUrl = URL.createObjectURL(content);
        const dlLink = document.createElement('a');
        dlLink.href = dlUrl;
        dlLink.download = `${handle}-media.zip`;
        document.body.appendChild(dlLink);
        dlLink.click();
        dlLink.remove();
        URL.revokeObjectURL(dlUrl);

        btn.textContent = 'Downloaded ✓';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
      } catch (err) {
        console.error('Download all failed:', err);
        btn.textContent = 'Failed — retry';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
      }
    });
  });

  /* ────────────────────────────────────────────────────────────────
     Download SINGOLO item (foto o video): click → scarica il blob, NON
     naviga/play. Cross-origin CDN Shopify ha CORS * → fetch ok.
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-rsf-download-img]').forEach((a) => {
    a.addEventListener('click', async (e) => {
      e.preventDefault();
      const url = a.href;
      const filename = a.dataset.filename || a.getAttribute('download') || 'download';
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error('fetch ' + res.status);
        const blob = await res.blob();
        const dlUrl = URL.createObjectURL(blob);
        const dl = document.createElement('a');
        dl.href = dlUrl; dl.download = filename;
        document.body.appendChild(dl); dl.click(); dl.remove();
        URL.revokeObjectURL(dlUrl);
      } catch (err) {
        console.error('single download failed:', err);
        window.open(url, '_blank'); // fallback
      }
    });
  });

  /* ────────────────────────────────────────────────────────────────
     Wishlist placeholder (TODO: integrare wishlist plugin)
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-rsf-wishlist]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.textContent = btn.textContent.trim() === 'Add to wishlist' ? 'Saved ✓' : 'Add to wishlist';
    });
  });

  /* ────────────────────────────────────────────────────────────────
     Breadcrumb back-link — preserva query string (filtri PLP) dal referrer.
     Liquid in PDP usa `collection` global var → href senza query string.
     Se referrer è la stessa collection con filtri (?filter.p.m.…), usa quel URL.
     ──────────────────────────────────────────────────────────────── */
  (function preserveBreadcrumbFilters() {
    const link = document.querySelector('.rsf-pdp-head__breadcrumb a');
    if (!link || !document.referrer) return;
    try {
      const ref = new URL(document.referrer);
      const cur = new URL(link.href, location.origin);
      if (ref.host === location.host && ref.pathname === cur.pathname && ref.search) {
        link.href = ref.toString();
      }
    } catch (_) {}
  })();

  /* ────────────────────────────────────────────────────────────────
     Back-in-Stock trigger — Back in Stock by AMP (backinstock.useamp.com)
     Widget injected: <div class="bis-reset bis-edge-right"><img class="BIS_trigger"></div>
     Trigger: simula click su img.BIS_trigger (il container è hidden via CSS).
     ──────────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-rsf-bis-trigger]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const trigger = document.querySelector('.BIS_trigger');
      if (trigger) { trigger.click(); return; }
      // Fallback API se widget non ancora caricato
      const variantId = btn.dataset.variantId;
      const productId = btn.dataset.productId;
      if (typeof window.BISPopover === 'function') {
        window.BISPopover({ variantId, productId });
        return;
      }
      console.warn('[RSF] BIS trigger not found — script useamp.com non caricato?');
    });
  });
})();
